import axios from 'Axios';
import { useState } from 'react';
import { Key } from 'tabler-icons-react';
import { api, toastify } from 'Utils';
import { ContentBox, SubmitButton, FieldMessage } from 'Elements';
import styles from 'partials/dashboard/user-form.module.scss';
import buttonStyles from 'partials/button.module.scss';

export const UserPasswordForm = ({ user }) => {
	const [state, setState] = useState({
		fields: {
			password: '',
			password_confirmation: ''
		},
		isSubmiting: false,
		errors: {}
	});

	const handleInput = (e) => {
		const target = e.target;
		const fields = state.fields;
		fields[target.name] = target.value;

		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const validateForm = () => {
		const fields = state.fields;
		let formIsValid = true;
		let errors = {};
		if (!fields.password) {
			formIsValid = false;
			errors['password'] = 'کلمه عبور جدید را وارد کنید';
		}
		if (!fields.password_confirmation) {
			formIsValid = false;
			errors['password_confirmation'] = 'تکرار کلمه عبور را وارد کنید';
		}
		if (fields.password !== fields.password_confirmation) {
			formIsValid = false;
			errors['password_confirmation'] = 'تکرار کلمه عبور مطابقت ندارد';
		}

		setState((prev) => ({
			...prev,
			errors
		}));
		return formIsValid;
	};

	const resetForm = () => {
		const fields = {
			password: '',
			password_confirmation: ''
		};
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const data = {
			...state.fields,
			...{
				mobile: user.mobile
			}
		};
		if (validateForm()) {
			setState((prev) => ({
				...prev,
				isSubmiting: true
			}));
			axios.post(api.changePassword, data).then((res) => {
				setState((prev) => ({
					...prev,
					isSubmiting: false
				}));
				if (res.status === 200) {
					const data = res.data;
					if (data.success) {
						toastify('کلمه عبور با موفقیت تغییر یافت', 'success');
						resetForm();
					} else {
						toastify(data.message);
					}
				} else {
					toastify('خطا در برقراری ارتباط با سرور');
				}
			});
		}
	};

	return (
		<ContentBox title="تغییر کلمه عبور" icon={Key}>
			<form className={styles.form} onSubmit={handleSubmit}>
				<div className={styles.field}>
					<label htmlFor="password" className={styles.label}>
						کلمه عبور جدید
					</label>
					<input
						type="password"
						id="password"
						name="password"
						className={styles.input}
						onChange={handleInput}
					/>
					{state.errors.password && (
						<FieldMessage text={state.errors.password} />
					)}
				</div>
				<div className={styles.field}>
					<label
						htmlFor="password_confirmation"
						className={styles.label}>
						تکرار کلمه عبور
					</label>
					<input
						type="password"
						id="password_confirmation"
						name="password_confirmation"
						className={styles.input}
						onChange={handleInput}
					/>
					{state.errors.password_confirmation && (
						<FieldMessage
							text={state.errors.password_confirmation}
						/>
					)}
				</div>
				<SubmitButton
					className={[styles.submit, buttonStyles.btn].join(' ')}
					disabled={state.isSubmiting}
					title="ذخیره"
				/>
			</form>
		</ContentBox>
	);
};
